import { render } from "./LiveReplay.vue?vue&type=template&id=6c1421c0&scoped=true"
import script from "./LiveReplay.vue?vue&type=script&lang=js"
export * from "./LiveReplay.vue?vue&type=script&lang=js"

import "./LiveReplay.vue?vue&type=style&index=0&id=6c1421c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1421c0"]])

export default __exports__